/**
 * Initializes scroll animations for elements with the class 'animate-on-scroll'
 * This function sets up Intersection Observer to detect when elements come into view
 * and adds the 'animated' class to trigger the animations
 */
export const initScrollAnimations = () => {
  // Check if IntersectionObserver is supported
  if (!('IntersectionObserver' in window)) {
    // If not supported, simply show all elements without animation
    const elements = document.querySelectorAll('.animate-on-scroll, .animate-large, .animate-hero');
    elements.forEach(el => el.classList.add('animated'));
    return;
  }

  // Clear any existing observer to prevent duplicates
  if (window.scrollAnimationObserver) {
    window.scrollAnimationObserver.disconnect();
    delete window.scrollAnimationObserver;
  }

  // Options for the observer - more conservative for iOS
  const options = {
    root: null, // Use the viewport as the root
    rootMargin: '20px', // Reduced margin for better iOS compatibility
    threshold: 0.05 // Lower threshold for better iOS compatibility
  };

  // Create the observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Add the animated class to trigger the animation
        entry.target.classList.add('animated');
        // Stop observing the element once it's animated
        observer.unobserve(entry.target);
      }
    });
  }, options);

  // Observe all elements with animation classes
  const elements = document.querySelectorAll('.animate-on-scroll, .animate-large, .animate-hero');
  
  // Only observe elements that haven't already been animated
  const elementsToObserve = Array.from(elements).filter((el) => !el.classList.contains('animated'));
  
  elementsToObserve.forEach(element => {
    observer.observe(element);
  });
  
  // Store observer globally to prevent duplicates
  window.scrollAnimationObserver = observer;
};

export default initScrollAnimations; 